module.exports = __webpack_public_path__ + "img/login-evo-bg.fbaa1080.png";